import { render, staticRenderFns } from "./CRMImport.vue?vue&type=template&id=4b83432f&scoped=true&"
import script from "./CRMImport.vue?vue&type=script&lang=js&"
export * from "./CRMImport.vue?vue&type=script&lang=js&"
import style0 from "./CRMImport.vue?vue&type=style&index=0&id=4b83432f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83432f",
  null
  
)

export default component.exports